import { render, staticRenderFns } from "./sd.vue?vue&type=template&id=2dfede25&scoped=true"
import script from "./sd.vue?vue&type=script&lang=js"
export * from "./sd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfede25",
  null
  
)

export default component.exports